import { css } from "styled-components";

export const fontUrl = (font) => `https://cdn.nested.com/fonts/${font}`;

/*
 * The second import is identical to the first except in name:
 * It's required for using light typography in graphs (line graph in AreaMarketReport) where we canot set font weight
 */

export const fonts = css`
  @font-face {
    font-display: swap;
    font-family: Euclid Circular B;
    src: url("${fontUrl("EuclidCircularB-Light-WebS.woff2")}") format("woff2"),
      url("${fontUrl("EuclidCircularB-Light-WebS.woff")}") format("woff");
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-display: swap;
    font-family: Euclid Circular B Light;
    src: url("${fontUrl("EuclidCircularB-Light-WebS.woff2")}") format("woff2"),
      url("${fontUrl("EuclidCircularB-Light-WebS.woff")}") format("woff");
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-display: swap;
    font-family: Euclid Circular B;
    src: url("${fontUrl("EuclidCircularB-Medium-WebS.woff2")}") format("woff2"),
      url("${fontUrl("EuclidCircularB-Medium-WebS.woff")}") format("woff");
    font-weight: 500;
    font-style: normal;
  }
`;
